import type { ChatReaction, ChatReactionChoice } from './types'

/*
 * The server's limits on a Message. `@orbit/api-types` isn't browser-safe at runtime,
 * so they're mirrored here and pinned to it by `contract.test.ts`.
 */

/** The longest text, in UTF-16 units as the server counts it, once trimmed. */
export const CHAT_MAX_LENGTH = 2000
/** Resources and members together. */
export const CHAT_MAX_TAGS = 10
/** Across every member a Message tags. */
export const CHAT_MAX_MENTIONS = 20
export const CHAT_MAX_PHOTOS = 10
/** The longest link the server previews; a longer one is skipped for the next. */
export const CHAT_LINK_MAX_LENGTH = 2048

/** The six reactions a member can pick, in the order they show. */
export const CHAT_REACTIONS: readonly ChatReactionChoice[] = ['ThumbsUp', 'Heart', 'Laugh', 'Wow', 'Sad', 'Pray']

const EMOJI: Record<ChatReactionChoice, string> = {
	ThumbsUp: '👍',
	Heart: '❤️',
	Laugh: '😂',
	Wow: '😮',
	Sad: '😢',
	Pray: '🙏',
}

/** Null for `Other`, a reaction added after this build shipped, which can't be shown. */
export const reactionEmoji = (reaction: ChatReaction): string | null =>
	reaction === 'Other' ? null : EMOJI[reaction]
